export default __webpack_public_path__ + "static/media/uin_export.131d318c.png";